export const MAX_RESULTS_AVAILABLE_CONNECTOR_LIST = 30;
